// top level "pack" file for webpack.
//
// This is for specifying what should be compiled as part of the asset bundle.
// TODO: import ahoy as a dependency when required.
// This is only imported here as ahoy appears to not be configured properly
// when directly imported.
import ahoy from 'ahoy.js';
// Set properties on `window` so they are globally available outside of js that
// is compiled as part of the asset bundle.
//
// Examples:
//   * JS written in a rails view or partial
//   * JS written in published content such as articles
import d3 from 'd3';

import '../../../node_modules/bootstrap/dist/js/bootstrap.min.js';
// TODO: Write test cases the exercise the functionality in the scripts imported
// below
import '../application/javascripts/analytics/google';
import engine from '../application/javascripts/app';
import {
  createLeadWithApple,
  logInWithApple,
  unlockContentWithApple,
} from '../application/javascripts/apple-login';
import '../application/javascripts/article-share-modal';
import '../application/javascripts/articles/featured';
import '../application/javascripts/awarenessBar';
import '../application/javascripts/banners/immersive-article-bottom-banner';
import '../application/javascripts/briefings/related';
import '../application/javascripts/comments/comment-form';
import '../application/javascripts/comments/comment-thread';
import '../application/javascripts/comments/like';
import '../application/javascripts/emailCapture';
import '../application/javascripts/forms/locked-homepage-lead-capture';
import {
  createLeadWithGoogle,
  logInWithGoogle,
  unlockContentWithGoogle,
} from '../application/javascripts/google-login';
import '../application/javascripts/modal';
import '../application/javascripts/newsletter-card';
import '../application/javascripts/newsletter-share-modal';
import '../application/javascripts/newsletter_feed';
import '../application/javascripts/newsletter_index';
import createAhoyEvent from '../application/javascripts/payments/stripe/analytics';
import '../application/javascripts/payments/stripe/analytics';
import '../application/javascripts/payments/stripe/credit-card';
import '../application/javascripts/payments/stripe/payment-button';
import '../application/javascripts/payments/stripe/tabbed-payment-options';
import { stopSubmitIndicator } from '../application/javascripts/payments/submit-indicator';
import openModalSlide from '../application/javascripts/slideup-modal';
// import files not directly referenced. Most of these setup event handlers or
// call some function that needs to be ran when the pack bundle is loaded.
import '../application/javascripts/subscribe-pages';
import { updateShowPaymentForm } from '../application/javascripts/subscribe-utils';
import trackEvent from '../application/javascripts/tracking';
import '../application/javascripts/ui/flash';
import '../application/javascripts/url/clean-params';
import { dispatchScriptLoadedEvent, ready } from '../application/javascripts/utils';
import initializeEmbeddedVideos from '../application/javascripts/videos/init';
import initializeTracking from '../application/javascripts/videos/tracking';

window.d3 = d3;
window.initializeEmbeddedVideos = initializeEmbeddedVideos;
window.initializeTracking = initializeTracking;
window.dispatchScriptLoadedEvent = dispatchScriptLoadedEvent;
window.createAhoyEvent = createAhoyEvent;
window.engine = engine;
window.trackEvent = trackEvent;
window.ready = ready;
window.stopSubmitIndicator = stopSubmitIndicator;
window.openModalSlide = openModalSlide;
window.logInWithGoogle = logInWithGoogle;
window.logInWithApple = logInWithApple;
window.createLeadWithGoogle = createLeadWithGoogle;
window.createLeadWithApple = createLeadWithApple;
window.updateShowPaymentForm = updateShowPaymentForm;

// These functions are overriden in test files. The scoping here is not to
// satisfy an application dependency.
window.unlockContentWithGoogle = unlockContentWithGoogle;
window.unlockContentWithApple = unlockContentWithApple;

// The `render` function is similar to `timeago` which is a library that used to
// be vendor'd in via sprockets. The interface is slighty different as it
// expects either a single node or a nodeList. A query that results in an empty
// set will break.
window.timeago = (nodeList) => {
  nodeList.length > 0 && render(nodeList);
};

// These values are the same as above but are also set to be globally available
// within webpack compiled scripts. This is handled in environment.js. They are
// set on the window to satisy any expectations about how they are called.
window.Cookies = Cookies;
window.$ = $;

// rails UJS is required for the "unobtrusive javascript" behavior that augments
// a variety of behaviors in a rails app.
var railsUJS = require('@rails/ujs');
railsUJS.start();

// application and components are the two directories that are compiled. This
// can be further split out to improve page performance in the future.
var applicationRequireContext = require.context('application', true);
var componentRequireContext = require.context('components', true);
var ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(applicationRequireContext);
ReactRailsUJS.useContext(componentRequireContext);
